/**
 * @license
 * Copyright Piotr Stępniewski <k3nsei.pl@gmail.com> All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/k3nsei/ng-in-viewport/stable/LICENSE
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { InViewportDirective } from './in-viewport.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [InViewportDirective],
  exports: [InViewportDirective],
})
export class InViewportModule {}
